import { useEffect, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import FiscalDocumentDownload from "./FiscalDocumentDownload.jsx";
import api from "@/api/api.js";
import { FISCAL_DOCUMENTS, complianceTone } from "@/utils/fiscalDocuments.js";

/**
 * El histórico de un tipo de documento: el vigente arriba y los anteriores
 * debajo, que no se borran nunca. De la 32/D se muestra además el semáforo.
 */
const FiscalDocumentList = ({ company, type = "fiscalCertificate" }) => {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState([]);
  const { route } = FISCAL_DOCUMENTS[type];
  const showStatus = type === "complianceOpinion";

  useEffect(() => {
    let active = true;
    api
      .get(`/companies/${company.id}/${route}/all`)
      .then(({ data }) => active && setDocuments(data))
      .catch(() => active && setDocuments([]));
    return () => {
      active = false;
    };
  }, [company.id, route]);

  if (documents.length === 0) {
    return <p className="text-muted m-3">{t("ui.noDocumentsYet")}</p>;
  }

  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th>{t("ui.version")}</th>
          <th>{t("ui.uploadedAgo")}</th>
          <th>{t("ui.exactDate")}</th>
          {showStatus && <th>{t("ui.complianceStatus")}</th>}
          <th>{t("ui.uploadedBy")}</th>
          <th>{t("ui.file")}</th>
        </tr>
      </thead>
      <tbody>
        {documents.map((document) => (
          <tr key={document.id}>
            <td>
              {document.version}
              {document.current && (
                <Badge bg="primary" className="ms-2">
                  {t("ui.current")}
                </Badge>
              )}
            </td>
            <td>{document.createdAtHuman}</td>
            <td>{document.createdAt}</td>
            {showStatus && (
              <td>
                <Badge bg={complianceTone(document.complianceStatus).variant}>
                  {t(`ui.compliance.${document.complianceStatus}`)}
                </Badge>
              </td>
            )}
            <td>{document.uploadedBy || "—"}</td>
            <td>
              <FiscalDocumentDownload
                companyId={company.id}
                documentId={document.id}
                type={type}
                fileName={document.originalName}
                className="btn btn-sm btn-outline-primary"
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default FiscalDocumentList;
